/**
 * Adds a link to a correlation.
 *
 * @param {Correlation} correlation
 * @param {Link} link
 */
export function addLink(correlation, link) {
    correlation.link.push(link);
    return correlation;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkTGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvY29ycmVsYXRpb24vYWRkTGluay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQTs7Ozs7R0FLRztBQUNILE1BQU0sVUFBVSxPQUFPLENBQUMsV0FBd0IsRUFBRSxJQUFVO0lBQzFELFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQzVCLE9BQU8sV0FBVyxDQUFDO0FBQ3JCLENBQUMifQ==